module.exports = __webpack_public_path__ + "static/media/user.1897f975.jpg";